<template>
  <div class="app-container">
    <BjDivider right-fixed>{{ $t('BusinessImportHistory.page.GeneralImport') }}
      <template slot="right">
        <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="handleConfirm('form')">{{ $t('saveText') }}</el-button>
      </template>
    </BjDivider>
    <el-form ref="form" :inline="true" :model="form" :rules="rules" label-width="180px">
      <el-row>
        <el-form-item prop="templateName" :label="$t('BusinessImportHistory.page.templateName')">
          <BjInput v-model="form.templateName" />
        </el-form-item>
        <el-form-item prop="templateCode" :label="$t('BusinessImportHistory.page.templateCode')">
          <BjInput v-if="!isEdit" v-model="form.templateCode" />
          <span v-else>{{ form.templateCode }}</span>
        </el-form-item>
        <el-form-item prop="templateType" :label="$t('BusinessImportHistory.page.TemplateType')">
          <BjSelectLov v-model="form.templateType" disabled :option-list="IMPORT_GENERAL_TYPE_LIST" />
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item prop="prefixPatch" :label="$t('BusinessImportHistory.page.pathPrefix')">
          <BjInput v-model="form.prefixPatch" />
        </el-form-item>
        <el-form-item prop="description" :label="$t('BusinessImportHistory.page.Description')">
          <BjInput v-model="form.description" />
        </el-form-item>
        <el-form-item prop="fragmentFlag" :label="$t('BusinessImportHistory.page.Slicing')">
          <el-switch v-model="form.fragmentFlag" :active-value="1" :inactive-value="0" />
        </el-form-item>
        <el-form-item prop="enabledFlag" :label="$t('enableText')">
          <el-switch v-model="form.enabledFlag" :active-value="1" :inactive-value="0" />
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item prop="" :label="$t('BusinessImportHistory.page.CustomTemplate')">
          <BjUpload ref="BjUpload" auto-upload @afterUpload="afterUpload"> </BjUpload>
          <BjViewUrl v-if="form.templateUrl" :url="form.templateUrl" style="width: 100px" />
        </el-form-item>
      </el-row>

      <BjDivider>{{ $t('BusinessImportHistory.page.SheetPage') }}
        <template slot="right">
          <el-button type="primary" @click="onAddSheet">{{ $t('addText') }}</el-button>
        </template>
      </BjDivider>
      <el-table :data="form.templateTargetList" stripe border>
        <el-table-column prop="sheetIndex" :label="$t('BusinessImportHistory.page.numberPage')" align="center">
          <template slot-scope="{ row, $index }">
            <el-form-item :prop="`templateTargetList.${$index}.sheetIndex`" :rules="rules.sheetIndex">
              <BjSelectLov v-model="row.sheetIndex" :option-list="SHEET_INDEX_LIST" />
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="sheetName" :label="$t('BusinessImportHistory.page.PageName')" align="center">
          <template slot-scope="{ row, $index }">
            <el-form-item :prop="`templateTargetList.${$index}.sheetName`" :rules="rules.sheetName">
              <BjInput v-model="row.sheetName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BusinessImportHistory.page.PleasePageName')" clearable />
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="startLine" :label="$t('BusinessImportHistory.page.startLine')" align="center">
          <template slot-scope="{ row }">
            <el-input-number v-model="row.startLine" :min="1" :precision="0" :controls="false" />
          </template>
        </el-table-column>
        <el-table-column prop="enabledFlag" :label="$t('enableText')" align="center">
          <template slot-scope="{ row }">
            <el-checkbox v-model="row.enabledFlag" :true-label="1" :false-label="0" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('table.operationText')" align="center">
          <template slot-scope="{ row, $index }">
            <el-button v-if="row.id" type="text" @click="onShow(row)">{{ $t('BusinessImportHistory.page.templateColumns') }}</el-button>
            <el-button type="text" @click="onDelete($index)">{{ $t('delText') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
  </div>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import { IMPORT_GENERAL_TYPE_LIST } from '@/utils/constants';
import { importApi } from '@/api';
import BjUpload from '@/components/BjUpload/index';
const defaultForm = () => {
  return {
    description: null,
    enabledFlag: 1,
    fragmentFlag: 0,
    prefixPatch: '/lgit', // 固定值
    templateCode: null,
    templateFileName: null,
    templateName: null,
    templateType: 'C',
    tenantId: 0,
    templateUrl: null,
    templateTargetList: [],
  };
};
const defaultSheetData = () => {
  return {
    sheetIndex: null,
    sheetName: null,
    startLine: 2,
    // validateSet: null,
    enabledFlag: 1,
  };
};
export default {
  components: { BjUpload },
  mixins: [viewMiXin],
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      IMPORT_GENERAL_TYPE_LIST,
      form: defaultForm(),
      rules: {
        templateName: [{ required: true, message: this.$t('BusinessImportHistory.page.PleaseTemplateName'), trigger: 'blur' }],
        templateCode: [{ required: true, message: this.$t('BusinessImportHistory.page.PleasetemplateCode'), trigger: 'blur' }],
        templateType: [{ required: true, message: this.$t('BusinessImportHistory.page.PleaseTemplateType'), trigger: 'change' }],
        prefixPatch: [{ required: true, message: this.$t('BusinessImportHistory.page.PleasePathPrefix'), trigger: 'blur' }],
        sheetIndex: [{ required: true, message: this.$t('BusinessImportHistory.page.PleaseSheetPage'), trigger: ['blur', 'change'] }],
        sheetName: [{ required: true, message: this.$t('BusinessImportHistory.page.PleasePageName'), trigger: ['blur', 'change'] }],
      },
    };
  },
  computed: {
    SHEET_INDEX_LIST() {
      const Arr = new Array(10).fill({}).map((e, index) => {
        return {
          value: index,
          label: 'Sheet' + (index + 1),
        };
      });
      return Arr;
    },
  },
  watch: {
    info(v) {
      this.form = v;
    },
  },
  mounted() {},
  methods: {
    /** 新增Sheet页 */
    onAddSheet() {
      this.form.templateTargetList.push(defaultSheetData());
    },
    afterUpload(url) {
      this.form.templateUrl = url;
    },
    /** 维护模板列 */
    onShow(row) {
      const { id } = row;
      this.$toPage('BusinessImportGeneralColumn', { id });
    },
    /** 删除Sheet页 */
    onDelete(index) {
      this.form.templateTargetList.splice(index, 1);
    },
    /* 关闭弹窗 */
    handleClose() {
      this.cancel({
        name: 'BusinessImportGeneralIndex',
      });
    },
    handleConfirm(formName) {
      const API_DATA = this.$lodash.clone(this.form);
      this.$refs[formName].validate(valid => {
        if (!valid) return this.$scrollToFormError();
        this.sendApi(API_DATA);
      });
    },
    sendApi(data) {
      const API = this.isEdit ? 'putImportTemplateHeaders' : 'addImportTemplateHeaders';
      importApi[API](data).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.complete('BusinessImportGeneralIndex');
          }, 500);
        }
      });
    },
  },
};
</script>
<style scoped>
.el-form-item--mini.el-form-item {
  margin: 15px 0;
}
</style>
